// extracted by mini-css-extract-plugin
export default {"container":"QD-z","innerContainer":"RD-z","multipleLines":"SD-z","heading":"TD-z","content":"UD-z","linkColor":"VD-z"};